import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { GuestGuard } from 'src/auth/guard';
import { AuthSplitLayout } from 'src/layouts/auth-split';
import { AuthModernLayout } from 'src/layouts/auth-modern';
import { SplashScreen } from 'src/components/loading-screen';

const SignInPage = lazy(() => import('src/pages/auth/jwt/sign-in/page'));
const SignUpPage = lazy(() => import('src/pages/auth/jwt/sign-up/page'));
const ForgotPasswordPage = lazy(() => import('src/pages/auth/jwt/forgot-password/page'));

const ModernLayout = ({ children }) => (
  <AuthModernLayout
    backgroundImage="/assets/background/login-bg.webp"
    overlayOpacity={0.5}
  >
    {children}
  </AuthModernLayout>
);

export const authRoutes = [
  {
    path: 'auth',
    element: (
      <Suspense fallback={<SplashScreen />}>
        <Outlet />
      </Suspense>
    ),
    children: [
      {
        path: 'jwt',
        children: [
          {
            path: 'sign-in',
            element: (
              <GuestGuard>
                <ModernLayout>
                  <SignInPage />
                </ModernLayout>
              </GuestGuard>
            ),
          },
          {
            path: 'sign-up',
            element: (
              <GuestGuard>
                <AuthSplitLayout>
                  <SignUpPage />
                </AuthSplitLayout>
              </GuestGuard>
            ),
          },
          {
            path: 'forgot-password',
            element: (
              <GuestGuard>
                <ModernLayout>
                  <ForgotPasswordPage />
                </ModernLayout>
              </GuestGuard>
            ),
          },
        ],
      },
    ],
  },
];
